module.exports = __webpack_public_path__ + "img/4-1.4405d343.svg";